module.exports = __webpack_public_path__ + "media/images/products/discovery-retailers-details-69ebf517d040a488f63f4a91ab21bb75.jpg";